import { useEffect, useRef, useState } from "react";
import { useInView } from "@/lib/motion";

export const Counter = ({ to, duration = 1800, prefix = "", suffix = "", testId, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { threshold: 0.4 });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVal(to);
      return;
    }
    let raf;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const e = 1 - Math.pow(1 - p, 4);
      setVal(Math.round(to * e));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);
  return (
    <span ref={ref} className={`font-mono-data ${className}`} data-testid={testId} data-target={to}>
      {prefix}
      {val}
      {suffix}
    </span>
  );
};
